import React from 'react'
import { ConnectKitButton } from 'connectkit'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import logo from './logo.png'
const Navbar = () => {
    return (
        <>
            {/* <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">

                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} className="navbar-brand" to="/">Ashar DApp</Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo03" aria-controls="navbarTogglerDemo03" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarTogglerDemo03">

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                            <li className="nav-item">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} className="nav-link " aria-current="page" to="/">Swap</Link>
                            </li>
                            <li className="nav-item">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} className="nav-link" to="/erc721">Mint NFT</Link>
                            </li>


                        </ul>
                        <div className="d-flex">
                            <ConnectKitButton showBalance={true} />

                        </div>

                    </div>
                    

                </div>
            </nav> */}
            <nav style={{ backgroundColor: "#23153c" }} class="navbar-expand-lg navbar sticky-top">
                <div class="container-fluid px-lg-5">
                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="navbar-brand d-none d-lg-block" to="/">
                        <img src={logo} alt="Logo" width="60" class="d-inline-block align-text-top" />
                        {/* Bootstrap */}
                    </Link>

                    {/* <!-- Toggler for small screens --> */}
                    <button class="navbar-toggler d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
                        <i class="fa-solid fa-bars-staggered fa-2xl" style={{ color: "white" }}></i>

                    </button>

                    {/* <!-- Offcanvas for small screens --> */}
                    <div style={{ backgroundColor: "#23153c" }} class="offcanvas offcanvas-start d-lg-none" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
                        <div class="offcanvas-header">
                            <h5 class="offcanvas-title text-light" id="offcanvasNavbarLabel">Vertex Chain</h5>
                            <button style={{ filter: "invert(1)", opacity: 1 }} type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>

                        </div>
                        <div class="offcanvas-body">
                            <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                                <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/">Home</Link>
                                </li>

                                <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/education">Education</Link>
                                </li>

                                <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/about">About</Link>
                                </li>

                                <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                    <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/contact">Contact</Link>
                                </li>

                            </ul>
                            {/* <div class="d-flex mt-3">
                    <button class="btn btn-outline-success">Login Here</button>
                </div> */}
                        </div>
                    </div>

                    {/* <!-- Normal navbar for larger screens --> */}
                    <div class="collapse navbar-collapse d-lg-flex justify-content-center" id="navbarNav">
                        <ul class="navbar-nav">
                            <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/">Home</Link>
                            </li>

                            <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/education">Education</Link>
                            </li>

                            <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/about">About</Link>
                            </li>

                            <li data-bs-dismiss="offcanvas" class="nav-item px-2">
                                <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} class="nav-link text-light active" aria-current="page" to="/contact">Contact</Link>
                            </li>


                        </ul>
                    </div>

                    {/* <!-- Login button on desktop --> */}
                    <div class=" ms-auto">
                        <Link onClick={() => window.scrollTo({ behavior: 'instant', top: 0, left: 0 })} to="/sign-in"><button class="btn btn-outline-light">Login Here</button></Link>
                    </div>
                </div>
            </nav>


        </>
    )
}

export default Navbar